/**
 * Viewport mode from env: when true, use responsive viewport (width=device-width).
 * When false, use fixed width (DESKTOP_VIEWPORT) for desktop-style layout on mobile.
 * Single source of truth for VITE_USE_VIEWPORT.
 */
const USE_RESPONSIVE_VIEWPORT = import.meta.env.VITE_USE_VIEWPORT !== 'false'

/**
 * Hook: whether to use responsive viewport (true) or desktop-on-mobile (false).
 * Use in Layout/Header for viewport meta and compact header styling.
 */
export function useViewport() {
  return USE_RESPONSIVE_VIEWPORT
}

/** For use outside React (e.g. main.jsx). */
export { USE_RESPONSIVE_VIEWPORT }

/**
 * Desktop-on-mobile viewport for every screen (Layout, login, reset-password).
 * Reference panel ships NO viewport meta (it is commented out in its index.html), so a
 * phone lays the page out at the browser default of 980px and shrinks it to fit.
 * 980 matters: it is BELOW bootstrap's lg breakpoint (992px), so `col-lg-*` stacks full
 * width on phones exactly like the reference. The old 1020 was above it (3 columns).
 */
export const DESKTOP_VIEWPORT = 'width=980'
